import React from 'react'
import styled from 'styled-components'

const CourseCard = ({item}) => {

    const TectItem = ({item})=>{
        return(
            <div>
                <p className='tech-item'>{item}</p>

            </div>
        )
    }

  return (
    <Wrapper>
    <div className='project-container'>
        <div className='left-container'>
            <img src={item.img} />
        </div>
        <div className='right-container'>
            <h1 className='project-name'>{item.courseName}</h1>
            <p>{item.description}</p>
         
            <a href={item.link} target="_blank" rel="noopener noreferrer">
      View Course
    </a>
          
        </div>
    </div>

    </Wrapper>

  )
}

const Wrapper = styled.section`
    box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
    border-radius: 1rem;
    margin: 2rem 0;
    /* background-color: red; */
    padding: 1rem;
    a{
        text-decoration:none;
        color: #D40B7E;
        font-weight: bold;
        font-size: small;
    }

img{
    /* max-height: 200px; */
    max-width: 140px;
    border-radius: 0.5rem;

}
.project-container{
    width: 100%;
    display: grid;
    grid-template-columns: 200px auto;

}
.left-container{
    /* height: 5rem; */
    display: flex;
    align-items: center;
    justify-content: center;
}
.right-container{
    padding: 1rem;
}
.project-name{
    font-size: larger;
    color: gray;
    margin-top: 0;
}
.tech-array-container{
    display: flex;
    /* overflow: hidden; */
}
.tech-item{
    padding: 0.5rem;
    border: 1px solid #D40B7E;
    margin-right: 0.4rem;
    border-radius: 0.3rem;
    font-size: small;
}
.tech-heading{
    font-size: small;
    color: gray;
    margin: 0;
    margin-bottom: 0.4rem;

}
@media (max-width: 500px) {
    .project-container {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
`

export default CourseCard